import { JFSRequest, executeRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { entityListResponseParser } from './getGlobalEntityQueue'

export const getMyQueueEntityList = (reqBody: any, ddListData: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getMyEntityQueue),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: reqBody,
  }

  return executeRequest(request)
    .then((resp) => entityListResponseParser(resp, ddListData))
    .catch((error) => {
      throw error
    })
}
